module.exports = __webpack_public_path__ + "img/interior.17fb2c08.png";